<app-header></app-header>
<main>

    <!--Contenido-->
    <div class="container">
        <div class="row">
            <div class="col-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item active" aria-current="page">Información de Denuncia</li>
                    </ol>
                </nav>
            </div>

            <div class="container">

                <h1 class="fw-bold mt-md-3;">Información de Denuncia</h1>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="col-12 card shadow-sm pt-4 pb-2">
            <div class="row">

                <div class="col-12 px-4">
                    <h2 class="fw-bold">Detalle de la Denuncia
                    </h2>
                </div>
                <div class="col-12 px-4">
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-4">
                        <div class="col-lg-2"><label>IDENTIFICADOR</label>
                            <p>{{infoDenuncia?.codigo}}</p>
                        </div>
                        <div class="col-lg-3"><label>FECHA DE INGRESO</label>
                            <p>{{formatoFecha(infoDenuncia?.fechaIngreso)}}</p>
                        </div>
                        <div class="col-lg-3"><label>FECHA DE RESOLUCIÓN</label>
                            <p>{{formatoFecha(infoDenuncia?.resolucion.fechaResolucion)}}</p>
                        </div>
                        <div class="col-lg-2"><label>ESTADO</label>
                            <p><span class="badge badge-celeste">{{obtenerEstado(infoDenuncia?.estId)}}</span></p>
                        </div>
                        <div class="col-lg-2"><label>DENUNCIANTE</label>
                            <p *ngIf="infoDenuncia?.anonimo">ANÓNIMO</p>
                            <p *ngIf="!infoDenuncia?.anonimo">VISIBLE</p>
                        </div>
                    </div>
                </div>
                <div class="container mt-5 pb-2">
                    <div class="accordion px-3 pb-2" id="accordionExample1">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button show" type="button" data-bs-toggle="collapse" 
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                    style="background-color: rgba(0,0,0,.03);color: black; text-size:12px; font-weight:bold;">
                                    <img src="../assets/img/tipo-denuncia.svg" style="margin-right: 5px;">
                                    Tipo(s) de Denuncia
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse"
                                aria-labelledby="headingOne">
                                <div class="accordion-body">
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1"  *ngFor="let prod of infoDenuncia?.propiedades" >{{infoDenuncia?.propiedades.length > 1 ? prod.nombre + ' - &nbsp;' : prod.nombre}}</label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container mt-2 pb-2">
                    <div class="accordion px-3 pb-1" id="accordionExample2">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingtwo">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" 
                                     data-bs-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo" aria-controls="collapsetwo"
                                    style="background-color: rgba(0,0,0,.03);color: black; text-size:12px; font-weight:bold;">
                                    <img src="../assets/img/leer.svg" style="margin-right: 5px;">
                                    Antecedentes
                                </button>
                            </h2>
                            <div id="collapsetwo" class="accordion-collapse" 
                                aria-labelledby="headingtwo" >
                                <div class="accordion-body">
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Forma en que tomó conocimientos de
                                            los
                                            hechos</label>
                                        <p>{{infoDenuncia?.forma}}</p>
                                    </div>
                                    <hr>
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Descripción detallada de él o los
                                            hechos</label>
                                        <p>{{infoDenuncia?.descripcion}}</p>
                                    </div>
                                    <hr> 
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Involucrados en los
                                            hechos</label>
                                        <p>{{infoDenuncia?.involugrados}}</p>
                                    </div>
                                    <hr> 
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 card shadow-sm pt-4 pb-2">
                                                    <h2 class="fw-bold mt-4;">Los hechos denunciados involucran a: {{showInvolucran(infoDenuncia?.invoId)}}</h2>
                                                    <label  *ngIf="infoDenuncia?.invoId == 1 && infoDenuncia?.organizacion">Si es un trabajador de la organización ¿A que razón social corresponde?</label>
                                                    <label  *ngIf="infoDenuncia?.invoId == 1 && !infoDenuncia?.organizacion">Si no sabe ¿A qué departamento pertenece?</label>
                                                    <p  *ngIf="infoDenuncia?.invoId == 1 && infoDenuncia?.organizacion">{{infoDenuncia?.trabOrganizacion}}</p>
                                                    <p  *ngIf="infoDenuncia?.invoId == 1 && !infoDenuncia?.organizacion">{{infoDenuncia?.trabDepartamento}}</p>
                                                    <p  *ngIf="infoDenuncia?.invoId == 4">{{infoDenuncia?.trabOtro}}</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 card shadow-sm pt-4 pb-2">
                                                    <div class="row mt-3 hscroll">
                                                        <div class="table-responsive">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr ALIGN=center>
                                                                        <th>Adjunto</th>
                                                                        <th>Fecha de carga</th>
                                                                        <th>Tipo documento</th>
                                                                        <th>Opciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody *ngFor="let doc of infoDenuncia?.documentos">
                                                                    <tr ALIGN=center>
                                                                        <td>{{doc.nombre}}</td>
                                                                        <td>{{formatoFecha(doc.fecha)}}</td>
                                                                        <td>{{doc.tipo}}</td>
                                                                        <td>
                                                                            <div class="btn-group" role="group"
                                                                                aria-label="Basic example">
                                                                            
                                                                                <div class="dropdown" *ngIf="doc.tipo == 'Antecedentes Denunciante'"
                                                                                    data-bs-toggle="tooltip"
                                                                                    data-bs-title="Descargar Adjunto">
                                                                                    <button type="button" (click)="downloadFile(doc)"
                                                                                        class="btn btn-light"><img
                                                                                            src="../assets/img/descargar.svg"></button>
                                                                                </div>

                                                                                <div class="dropdown" *ngIf="verPdf(doc)"
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-title="Ver Documento">
                                                                                <button type="button" (click)="obtenerPdf(doc)"
                                                                                    class="btn btn-light"><img
                                                                                        src="../assets/img/ojo.svg" style="
                                                                                        width: 24px;
                                                                                        height: 24px;
                                                                                    "></button>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="container mt-2 pb-2" *ngIf="!infoDenuncia?.anonimo">
                    <div class="accordion px-3 pb-2" id="accordionExample3">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapsetree" aria-expanded="false"
                                    aria-controls="collapsetree"
                                    style="background-color: rgba(0,0,0,.03);color: black; text-size:12px; font-weight:bold;">
                                    <img src="../assets/img/person.svg" style="margin-right: 5px;">
                                    Datos Denunciante
                                </button>
                            </h2>
                            <div id="collapsetree" class="accordion-collapse"
                                aria-labelledby="headingOne">
                                <div class="accordion-body">
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Rut</label>
                                        <p>{{infoDenuncia?.rut}} </p>
                                    </div>
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Nombre</label>
                                        <p>{{infoDenuncia?.nombre}} {{infoDenuncia?.apellidos}} </p>
                                    </div>
                                    <hr> 
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Correo</label>
                                        <p>{{infoDenuncia?.correo}}</p>
                                    </div>
                                    <hr> 
                                    <div class=" mt-1">
                                        <label for="exampleFormControlTextarea1">Teléfono</label>
                                        <p>{{infoDenuncia?.fono}}</p>
                                    </div>
                                    <hr> 
                                </div>
                            </div>
                        </div>
                    </div>
                 
                </div> 

                <div class="col-12 px-4">
                    <div class="form-group px-3 pb-1">
                        <label for="exampleFormControlTextarea1">Resolución</label>
                        <textarea  [(ngModel)]="resolucion"  class="form-control" id="exampleFormControlTextarea1" rows="4" disabled></textarea>
                    </div>
                </div>
            </div>
        </div>
      


    </div>

 

    <div class="container d-flex justify-content-end pt-4 pb-4">
        <button class="btn btn-primary mx-2" [routerLink]="['/consulta']"><img src="../assets/img/undo.svg">&nbsp;Volver Listado
        </button>
    </div>


</main>
